import { baseUrl } from "@/config/env";
import request from "@/router/axios";
import { parseParam } from "@/util/util";
// setInstallType
export const setInstallType = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/installType/${params.id}/${params.installType}`,
    method: "POST",
  });
};
export const getDownloadCode = (params) => {
  return request({
    url: `${baseUrl}/joins-product/v1/app_product/downloadMiniProgramCodeImageV2`,
    method: "POST",
    responseType: "blob",
    data: params,
  });
};
// 获取代理商Id
export const getRootDepartmentId = () => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/department/getRootDepartmentId`,
    method: "GET",
  });
};
// 获取工程师信息
export const getUserInfo = (userId) => {
  return request({
    url: `${baseUrl}/joins-basic/v1/user/user_info/${userId}`,
    method: "GET",
  });
};
export const stockRemovalReturn = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/refuse`,
    method: "PUT",
    data: data,
  });
};
export const findWaterProject = (params) => {
  params = parseParam(params);
  params = params + "&type=PURE_WATER";
  return request({
    // url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/ListV2?` + params, 
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration?` + params,
    method: "GET",
  });
};
export const getMerchantOrder = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration?id=` + params,
    // url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/ListV2?id=` + params, 
    method: "GET",
  });
};export const getGoodList = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/goodList/` + params,
    method: "GET",
  });
}
export const editMerchantOrder = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration`,
    method: "PUT",
    data: data,
  });
};
export const downloadExcelCustomsDeclaration = (params) => {
  params = parseParam(params);
  params = params + "&type=PURE_WATER";
  return request({
    url:
      `${baseUrl}/joins-sales-cloud/v1/customs_declaration/downloadExcelCustomsDeclaration?` +
      params,
    method: "GET",
    responseType: "blob",
  });
};
export const findWaterProjectAll = () => {
  return request({
    url: `${baseUrl}/joins-sales/v1/classify/choose/agent`,
    method: "GET",
  });
};

export const addWaterProject = (data) => {
  return request({
    url: `${baseUrl}/joins-sales/v1/classify/agent`,
    method: "POST",
    data: data,
  });
};

export const editWaterProject = (data) => {
  return request({
    url: `${baseUrl}/joins-sales/v1/classify/agent`,
    method: "PUT",
    data: data,
  });
};

export const delWaterProject = (ids) => {
  let temp = ids.join(",");
  return request({
    url: `${baseUrl}/joins-sales/v1/classify/agent/${temp}`,
    method: "DELETE",
  });
};
export const chooseSecondWaterProject = (id) => {
  return request({
    url: `${baseUrl}/joins-sales/v1/classify/choose?superiorId=${id}`,
    method: "GET",
  });
};
export const handleRebates = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/audit/${data.id}`,
    method: "PUT",
    data,
  });
};
// 新增提货单
export const addDeliveryOrder = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/delivery_order`,
    method: "POST",
    data: data,
  });
};
//updateDeliveryOrder
export const updateDeliveryOrder = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/delivery_order`,
    method: "PUT",
    data: data,
  });
};
// toBulkDelivery
export const toBulkDelivery = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/delivery_order/batch`,
    method: "POST",
    data: data,
  });
};
export const handleDelayedInstallation = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/notInstalled`,
    method: "PUT",
    data: data,
  });
};
export const findViewServiceDiary = (id, params) => {
  params = parseParam(params);
  return request({
    url:
      `${baseUrl}/joins-work/v1/workOrder/findServiceRecordListOther/` +
      id +
      `?clientType=JOINS_ENGINEER` +
      "&" +
      params,
    method: "GET",
  });
};
export const returnMoney = (data) => {
  return request({
    url:
      `${baseUrl}/joins-sales-cloud/v1/app_customs_declaration/wx_refund/${data.id}` +
      "?refundAmount=" +
      data.refundAmount +
      "&reason=" +
      data.reason,
    method: "GET",
  });
};
// 售后报单
export const addAfterSaleOrder = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/engineering_order/after_sales`,
    method: "POST",
    data: data,
  });
};
